jQuery(document).ready(function($) {
  $('[data-class]').each(function () {
    var connectClass = $(this).data('class');

    var $targetMega = $('.mega-menu[data-class="' + connectClass + '"] .menu-container'); 
    var $sourceMega = $('.connect-mega[data-class="' + connectClass + '"]'); 

    if ($targetMega.length && $sourceMega.length) {
      var $content = $sourceMega.children(); 

      if ($content.length) {
        $targetMega.html('');
        $targetMega.append($content);
        $sourceMega.remove();
      }
    }
  });
});